var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddfilesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.984 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.807,54.239,27.59,50.032a3.44,3.44,0,0,0-1.128-.778,3.311,3.311,0,0,0-3.6.721L18.59,54.244a2.06,2.06,0,0,0,.335,3.187,2.091,2.091,0,0,0,2.616-.309l1.6-1.6v8.408a2.06,2.06,0,0,0,2.06,2.06h0a2.06,2.06,0,0,0,2.06-2.06V55.521L28.8,57.066a2.142,2.142,0,0,0,2.714.319,2.06,2.06,0,0,0,.293-3.146Z",
    transform: "translate(0 -15.04)",
    fill: "#fff",
    stroke: "#0fa9a6",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.111,19.2A4.119,4.119,0,0,0,46.2,18H33.149A5.149,5.149,0,0,0,28,23.149v4.634a2.06,2.06,0,0,0,4.119,0V23.149a1.03,1.03,0,0,1,1.03-1.03H46.2l5.489,5.489V45.8a1.03,1.03,0,0,1-1.03,1.03H38.813a2.06,2.06,0,1,0,0,4.119H50.656A5.149,5.149,0,0,0,55.8,45.8v-18.2a4.119,4.119,0,0,0-1.2-2.914Z",
    transform: "translate(-4.859 0)",
    fill: "#fff",
    stroke: "#0fa9a6",
    strokeWidth: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddfilesIcon);
export default __webpack_public_path__ + "static/media/addfiles-icon.671b615951018726c4034dbfcc7d05e8.svg";
export { ForwardRef as ReactComponent };